const Margin = [
    {id: "0", value: "融資"},    
    {id: "1", value: "融券"}, 
  ];  
  
  export default Margin